var _defs, _path, _path2, _path3, _path4, _rect, _path5, _path6, _polygon, _polygon2, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCcDiscover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 30.46",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "discover"
  }, "Discover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "discover"
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cc-discover1{fill:#f8f8f8;}.cc-discover2{fill:#e6863c;}.cc-discover3{fill:url(#radial-gradient);}.cc-discover4{fill:#051721;}.cc-discover5{fill:#221f20;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 18.15,
    cy: 505.33,
    r: 2.35,
    gradientTransform: "matrix(1, 0, 0, -1, 6.42, 520.08)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fbede1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fae8d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#f7dbc1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#f2c59c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#eca76c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5853c"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cc-discover1",
    d: "M47.78,28a1.6,1.6,0,0,1-1.6,1.59H1.78A1.6,1.6,0,0,1,.19,28V1.45A1.6,1.6,0,0,1,1.78-.14H46.22a1.6,1.6,0,0,1,1.59,1.59V28Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cc-discover2",
    d: "M13.28,29.61H46.22A1.6,1.6,0,0,0,47.81,28V16.9C44.63,18.91,32.71,25.82,13.28,29.61Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cc-discover3",
    d: "M24.59,12.42a2.32,2.32,0,1,0,0,4.63,2.32,2.32,0,1,0,0-4.63Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cc-discover4",
    d: "M11.08,12.5H9.79v4.44H11a2.18,2.18,0,0,0,1.59-.53,2.28,2.28,0,0,0,.8-1.71A2.17,2.17,0,0,0,11.08,12.5Zm1,3.38a1.56,1.56,0,0,1-1.17.34H10.7v-3h.23a1.64,1.64,0,0,1,1.17.34,1.46,1.46,0,0,1,.5,1.1A1.61,1.61,0,0,1,12.1,15.88Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cc-discover4",
    x: 13.89,
    y: 12.5,
    width: 0.87,
    height: 4.44
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cc-discover4",
    d: "M16.88,14.21c-.53-.19-.68-.31-.68-.57s.27-.5.65-.5a1,1,0,0,1,.68.34l.45-.6a1.91,1.91,0,0,0-1.32-.5,1.31,1.31,0,0,0-1.41,1.29c0,.61.27.91,1.1,1.22a2.08,2.08,0,0,1,.61.26.51.51,0,0,1,.27.46.65.65,0,0,1-.69.64,1,1,0,0,1-.95-.6l-.57.53a1.78,1.78,0,0,0,1.56.83,1.42,1.42,0,0,0,1.52-1.48C18.14,14.89,17.87,14.58,16.88,14.21Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cc-discover4",
    d: "M18.44,14.74a2.28,2.28,0,0,0,2.35,2.31,2.42,2.42,0,0,0,1.1-.26v-1a1.39,1.39,0,0,1-1.06.49,1.44,1.44,0,0,1-1.48-1.51,1.48,1.48,0,0,1,1.44-1.52,1.53,1.53,0,0,1,1.1.49v-1a2.2,2.2,0,0,0-1.06-.27A2.32,2.32,0,0,0,18.44,14.74Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cc-discover4",
    points: "28.91 15.5 27.7 12.5 26.75 12.5 28.65 17.09 29.14 17.09 31.04 12.5 30.09 12.5 28.91 15.5"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cc-discover4",
    points: "31.46 16.98 33.92 16.98 33.92 16.22 32.33 16.22 32.33 15 33.85 15 33.85 14.24 32.33 14.24 32.33 13.26 33.92 13.26 33.92 12.5 31.46 12.5 31.46 16.98"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cc-discover4",
    d: "M37.34,13.83c0-.84-.57-1.33-1.59-1.33H34.46v4.44h.87V15.15h.11l1.22,1.79h1.06l-1.41-1.86A1.15,1.15,0,0,0,37.34,13.83Zm-1.75.72h-.26V13.18h.26c.54,0,.84.23.84.65S36.16,14.55,35.59,14.55Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cc-discover5",
    d: "M38,12.84c0-.08,0-.11-.15-.11h-.12v.37h.08V13l.11.15H38L37.87,13C38,13,38,12.91,38,12.84Zm-.15.07h0V12.8h0s.07,0,.07,0A.08.08,0,0,1,37.8,12.91Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cc-discover5",
    d: "M37.83,12.57a.35.35,0,1,0,.34.34A.34.34,0,0,0,37.83,12.57Zm0,.65a.26.26,0,0,1-.26-.27.25.25,0,0,1,.26-.26.26.26,0,0,1,.27.26A.29.29,0,0,1,37.83,13.22Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcDiscover);
export default __webpack_public_path__ + "static/media/cc-discover.dfea6cdd3dffbd2269fda1ecb3da6812.svg";
export { ForwardRef as ReactComponent };